"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flat = exports.getExtension = exports.isCSS = exports.isJS = exports.LOCAL_DEV_HOSTS = exports.isBrowserMainThread = exports.isBrowser = exports.isServer = exports.isWorker = void 0;
const isWorker = () => typeof WorkerGlobalScope !== 'undefined';
exports.isWorker = isWorker;
const isServer = () => !exports.isWorker() && typeof window === 'undefined';
exports.isServer = isServer;
const isBrowser = () => typeof window !== 'undefined' && typeof window.document !== 'undefined';
exports.isBrowser = isBrowser;
const isBrowserMainThread = () => exports.isBrowser() && !exports.isWorker();
exports.isBrowserMainThread = isBrowserMainThread;
exports.LOCAL_DEV_HOSTS = [
    'https://bo.wix.com/suricate/tunnel/',
    'https://localhost:',
    'http://localhost:',
    'https://sled.wix.dev/',
];
function isJS(url) {
    return getExtension(url) === 'js';
}
exports.isJS = isJS;
function isCSS(url) {
    return getExtension(url) === 'css';
}
exports.isCSS = isCSS;
function getExtension(url) {
    return url.split('.').pop();
}
exports.getExtension = getExtension;
function flat(arr) {
    const result = [];
    const _flat = (_arr) => {
        _arr.forEach(element => {
            if (Array.isArray(element)) {
                _flat(element);
            }
            else {
                result.push(element);
            }
        });
    };
    _flat(arr);
    return result;
}
exports.flat = flat;
//# sourceMappingURL=utils.js.map